module.exports = {
      id: "dh-symbol-usage",
      viewBox: "0 0 344.84 299.91",
      url: __webpack_public_path__ + "svg-sprite-58d03b3f1466f1d475a0d37264fe8fc2.svg#dh-symbol",
      toString: function () {
        return this.url;
      }
    }